
import { VueModule } from '@Foundation/utilities';
import StickyBar from './code/Scripts/components/sticky-bar';

export default VueModule({
  components: {
    StickyBar
  }
});
